// 包含多个mutations中的方法名称的常量

export const ADD_GOODS = 'ADD_GOODS'; //添加到购物车
export const INIT_SHOP_CART = 'INIT_SHOP_CART'; //初始化购物车
export const CLEAR_CART = 'CLEAR_CART'; //清空购物车
export const USER_INFO = 'USER_INFO'; //用户信息
export const REDUCE_CART = 'REDUCE_CART'; //移除购物车
export const SET_LOGIN = 'SET_LOGIN';
export const SET_ROUND = 'SET_ROUND'; //获取比赛轮数


// WEBPACK FOOTER //
// ./src/store/mutations-type.js